<section id="agenda">
  <div class="jobs" [dir]="'Direction' | translate">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
      <div class="container" [dir]="'Direction' | translate">
        <span class="section-title">{{ "Header.Item7" | translate }}</span>
      </div>
      <div class="jobs-inner">
        <div class="summary-tabs mx-2">
          <button 
            class="btn btn-light" 
            [ngClass]="{'active': currentSummary === 'dividends'}"
            (click)="changeSummary('dividends')">{{ 'Dividends' | translate }}</button>
          <button 
            class="btn btn-light" 
            [ngClass]="{'active': currentSummary === 'genAssemblies'}"
            (click)="changeSummary('genAssemblies')">{{ 'GeneralAssemblies' | translate }}</button>
          <button 
            class="btn btn-light" 
            [ngClass]="{'active': currentSummary === 'bonusShares'}"
            (click)="changeSummary('bonusShares')">{{ 'BonusShares' | translate }}</button>
        </div>

        <!-- Bonus Shares Table -->
        <div *ngIf="currentSummary === 'bonusShares'" class="summary-details mx-2 my-2">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ "Company" | translate }}</th>
                  <th>{{ "Distribution" | translate }}</th>
                  <th>{{ "MaturityDate" | translate }}</th>
                  <th>{{ "DistributionDate" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let bonusShare of bonusShares | paginate: {id: 'pagination3', itemsPerPage: bonusSharesPageSize, currentPage: bonusSharesPage }">
                  <td>{{ bonusShare.bsCompName }}</td>
                  <td>{{ bonusShare.bsDistibution }}</td>
                  <td>{{ bonusShare.bsMatDate }}</td>
                  <td>{{ bonusShare.bsDistDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination Controls -->
          <pagination-controls id="pagination3" (pageChange)="bonusSharesPage = $event"></pagination-controls>
        </div>

        <!-- General Assemblies Table -->
        <div *ngIf="currentSummary === 'genAssemblies'" class="summary-details mx-2 my-2">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ "Name" | translate }}</th>
                  <th>{{ "Date" | translate }}</th>
                  <th>{{ "Address" | translate }}</th>
                  <th>{{ "Timing" | translate }}</th>
                  <th>{{ "Type" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let assembly of genAssemblies | paginate: {id: 'pagination2', itemsPerPage: genAssembliesPageSize, currentPage: genAssembliesPage }">
                  <td>{{ assembly.genIsinName }}</td>
                  <td>{{ assembly.genIsinDate | date : 'shortDate' }}</td>
                  <td>{{ assembly.genIsinAddress }}</td>
                  <td>{{ assembly.genIsinTiming }}</td>
                  <td>{{ assembly.genIsinType }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination Controls -->
          <pagination-controls id="pagination2" (pageChange)="genAssembliesPage = $event"></pagination-controls>
        </div>

        <!-- Dividends Table -->
        <div *ngIf="currentSummary === 'dividends'" class="summary-details mx-2 my-2">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ "Company" | translate }}</th>
                  <th>{{ "Currency" | translate }}</th>
                  <th>{{ "Address" | translate }}</th>
                  <th>{{ "Number" | translate }}</th>
                  <th>{{ "Value" | translate }}</th>
                  <th>{{ "MaturityDate" | translate }}</th>
                  <th>{{ "PayDate" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dividend of dividends | paginate: { id: 'paginationDividend',itemsPerPage: dividendsPageSize, currentPage: dividendsPage }">
                  <td>{{ dividend.divCompName }}</td>
                  <td>{{ dividend.divCurrency }}</td>
                  <td>{{ dividend.divAddess }}</td>
                  <td>{{ dividend.divNumber }}</td>
                  <td>{{ dividend.divValue }}</td>
                  <td>{{ dividend.divMatDate }}</td>
                  <td>{{ dividend.divPayDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination Controls -->
          <pagination-controls id="paginationDividend" (pageChange)="dividendsPage = $event"></pagination-controls>
        </div>

      </div>
    </div>
  </div>
</section>
<div class="empty-space"></div>